import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FiveBenefitsOfProfessionalWebDesigns } from './components/FiveBenefitsWebDesign';
import { Header } from './components/Header';

function Post2() {
  return (
    <div className="App">
      <Header />
      <FiveBenefitsOfProfessionalWebDesigns />
    </div>
  );
}

export default Post2;